import { supabase } from '../lib/supabaseClient';

// Gera ou recupera um ID único para o visitante (persistente no navegador)
const getVisitorId = () => {
  if (typeof window === 'undefined') return 'server';
  let id = localStorage.getItem('visitor_id');
  if (!id) {
    id = crypto.randomUUID?.() || Math.random().toString(36).substring(2) + Date.now().toString(36);
    localStorage.setItem('visitor_id', id);
  }
  return id;
};

// Verifica se a página já foi rastreada nesta sessão para evitar duplicatas em refresh
const wasTrackedInSession = (path: string) => {
  if (typeof window === 'undefined') return false;
  const sessionKey = `tracked_page_${path}`;
  if (sessionStorage.getItem(sessionKey)) return true;
  sessionStorage.setItem(sessionKey, 'true');
  return false;
};

export const trackEvent = async (type: 'page_view' | 'click', path: string, name?: string, metadata: any = {}) => {
  // Ignorar rastreamento se estiver no admin
  if (path.startsWith('/admin')) return;

  // Se for visualização de página, evitar duplicatas em refresh na mesma sessão
  if (type === 'page_view' && wasTrackedInSession(path)) {
    return;
  }

  try {
    const { error } = await supabase.from('analytics_events').insert([{
      event_type: type,
      page_path: path,
      event_name: name,
      metadata: {
        ...metadata,
        visitor_id: getVisitorId(),
        userAgent: navigator.userAgent,
        screenSize: `${window.innerWidth}x${window.innerHeight}`
      }
    }]);
    if (error) console.error('Tracking error:', error);
  } catch (err) {
    console.error('Failed to track event:', err);
  }
};
